import { faArrowRight, faCheck, faCircle, faExclamation } from "@fortawesome/free-solid-svg-icons"
import { Box, Step, Typography, useTheme } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { ExamFormContext } from "../ExamFormStateProvider"
import {
  StyledStepIcon,
  StyledStepLabel,
  StyledStepper,
  StyledTitleTypography,
  StyledTypography
} from "./StepperEl.styled"

const getStepAnswers = (questions, answers) => {
  return answers.filter((answer) => {
    return questions.questions.find((question) => question.id === answer.questionId)
  })
}

const stepIsAnswered = (questions, answers) => {
  const stepAnswers = getStepAnswers(questions, answers)
  if (questions.questions.length > stepAnswers.length) return false
  return answers.every((answer) => answer.answer.length > 0)
}

const stepRequiresMore = (questions, answers) => {
  const stepAnswers = getStepAnswers(questions, answers)
  if (questions.questions.length > stepAnswers.length) return true
  return false
}

const getStepIconData = (theme, stepProps, answers, questions) => {
  let color = theme.palette.primary["800"],
    backgroundColor = theme.palette.primary["300"],
    icon = faCircle
  if (stepProps.active) {
    color = theme.palette.secondary["700"]
    backgroundColor = theme.palette.primary["700"]
    icon = faArrowRight
  } else if (stepIsAnswered(questions, answers)) {
    color = theme.palette.green["900"]
    backgroundColor = theme.palette.green["200"]
    icon = faCheck
  } else if (stepRequiresMore(questions, answers) && !stepProps.completed) {
    color = theme.palette.secondary["300"]
    backgroundColor = theme.palette.primary["300"]
    icon = faArrowRight
  } else if (stepRequiresMore(questions, answers)) {
    color = theme.palette.warning["900"]
    backgroundColor = theme.palette.warning["200"]
    icon = faExclamation
  }
  return { color, backgroundColor, icon }
}
export const StepperEl = (props) => {
  const { t } = useTranslation()
  const { areas, activeStep, setActiveStep, handleSubmitForm, examQuestionCount } = props
  const answerContext = useContext(ExamFormContext)
  const [answers, setAnswers] = useState([])

  useEffect(() => {
    setAnswers(answerContext.values.current)
  }, [answerContext.values.current])

  const handleStep = (step) => () => {
    setActiveStep(step)
  }
  const theme = useTheme()

  return (
    <Box>
      <Typography color="textPrimary" marginBottom={3}>
        {t("learning.exams.titles.chapter", "Chapter")}
      </Typography>
      <StyledStepper activeStep={activeStep} orientation="vertical" connector={false}>
        {areas.map((questions, index) => (
          <Step key={index} sx={{ marginBottom: 3 }}>
            <StyledStepLabel
              StepIconComponent={(stepProps) => {
                const stepIconData = getStepIconData(theme, stepProps, answers, questions)
                return (
                  <StyledStepIcon
                    stepProps={stepProps}
                    answers={answers}
                    questions={questions}
                    activeStep={activeStep}
                    index={index}
                    icon={stepIconData.icon}
                    size="xs"
                    sx={{
                      backgroundColor: stepIconData.backgroundColor,
                      color: stepIconData.color
                    }}
                  />
                )
              }}
              onClick={handleStep(index)}>
              <StyledTitleTypography>
                {props?.currentTranslatedDetails?.examinationDefinition?.areas[index]?.title}
              </StyledTitleTypography>
              {questions.questions.length > 0 && (
                <StyledTypography>
                  {` ${
                    answers?.filter(
                      (answers) =>
                        answers?.answer?.length > 0 &&
                        questions?.questions.find((x) => x.id === answers.questionId)
                    )?.length
                  } / ${questions.questions.length} ${t(
                    "learning.exams.stepper.questions_left",
                    "Questions answered"
                  )}`}
                </StyledTypography>
              )}
            </StyledStepLabel>
          </Step>
        ))}
      </StyledStepper>
    </Box>
  )
}
